import React, { useCallback } from 'react';
import Editor from '../Editor/Editor';

const WhatsNewForm = ({ whatsNewConfig, setWhatsNewConfig }) => {
  const addNewUpdate = useCallback(() => {
    setWhatsNewConfig((prevConfig) => ({
      ...prevConfig,
      updates: [...(prevConfig.updates || []), ""]
    }));
  }, [setWhatsNewConfig]);

  const deleteUpdate = useCallback(
    (index) => {
      // Add confirmation before deleting
      if (window.confirm('Are you sure you want to delete this update?')) {
        setWhatsNewConfig((prevConfig) => ({
          ...prevConfig,
          updates: (prevConfig.updates || []).filter((_, i) => i !== index)
        }));
      }
    },
    [setWhatsNewConfig]
  );

  return (
    <div>
      <h2 className="text-white text-xl font-bold mb-4">What's New</h2>
      <div className="space-y-6">
        {(whatsNewConfig?.updates || []).map((update, index) => (
          <div key={`editor-wrapper-${index}`} className="relative">
            {/* <Editor
              defaultValue={update}
              editorId={`UpdateEditor_${index}`}
              index={index}
              configState={whatsNewConfig}
              setConfig={setWhatsNewConfig}
            /> */}
            <Editor
    editorId={`update_${index}`}
    value={update}
    onChange={(html) =>
      setWhatsNewConfig((prev) => ({
        ...prev,
        updates: (prev.updates || []).map((u, j) =>
          j === index ? html : u
        ),
      }))
    }
  />
            <button
              className="absolute top-2 right-2 p-1 bg-red-500 hover:bg-red-600 text-white rounded"
              onClick={() => deleteUpdate(index)}
              title="Delete this update"
            >
              Delete
            </button>
          </div>
        ))}
      </div>
      <button
        className="mt-6 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded transition-colors"
        onClick={addNewUpdate}
      >
        Add New Update
      </button>
    </div>
  );
};

export default WhatsNewForm;